function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_61",
  "data-name": "Group 61"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#1dbf73"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_59",
  "data-name": "Group 59",
  transform: "translate(24 14)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M.937,0V12.9",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31_Copy",
  "data-name": "Path 31 Copy",
  d: "M.937.9V1",
  transform: "translate(0 20)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 5
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_60",
  "data-name": "Group 60",
  transform: "translate(313 48)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval_Copy_21",
  "data-name": "Oval Copy 21",
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#1dbf73"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  "data-name": "Oval",
  cx: 11,
  cy: 11,
  r: 11,
  transform: "translate(13.75 14)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_12",
  "data-name": "Line 12",
  d: "M.25.25h0",
  transform: "translate(41.75 36)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M11.884.267.43,15.733",
  transform: "translate(18.727 16.733)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle",
  d: "M0,0,30.639,24.56,61.138,0,95,18.727,126.614,0l36.006,16.769L200,0V80a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5Z",
  transform: "translate(77 148)",
  fill: "#1dbf73",
  stroke: "#1dbf73",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.35
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_Copy_18",
  "data-name": "Rectangle Copy 18",
  d: "M0,5A5,5,0,0,1,5,0H195a5,5,0,0,1,5,5V78L163.249,94.953,126.517,78,94.439,94.953,61.795,78l-31.65,23.92L0,78Z",
  transform: "translate(77 58)",
  fill: "#1dbf73",
  stroke: "#1dbf73",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.28
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval-3",
  "data-name": "Oval",
  cx: 5,
  cy: 5,
  r: 5,
  transform: "translate(90 68)",
  fill: "#1dbf73"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval_Copy_20",
  "data-name": "Oval Copy 20",
  cx: 5,
  cy: 5,
  r: 5,
  transform: "translate(104 68)",
  fill: "#1dbf73"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  "data-name": "Rectangle",
  width: 137,
  height: 10,
  rx: 3,
  transform: "translate(125 68)",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_30_Copy",
  "data-name": "Path 30 Copy",
  d: "M0,0H86a2,2,0,0,1,2,2h0",
  transform: "translate(318 73) rotate(180)",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  strokeDasharray: "10 15"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M0,0H99a16,16,0,0,1,16,16V92",
  transform: "translate(44.351 25.385)",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  strokeDasharray: "10 15"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(256.557 88.163) rotate(45)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined_Shape",
  "data-name": "Combined Shape",
  d: "M35.035,80a39.4,39.4,0,0,1-20.166-5.517A40.113,40.113,0,0,1,.585,60H34.741a10.011,10.011,0,0,0,10-10V31.053a10.011,10.011,0,0,0-10-10H0A40.088,40.088,0,0,1,14.355,5.826a39.585,39.585,0,0,1,48.8,5.89,39.973,39.973,0,0,1,6.916,9.337h79.454a19.474,19.474,0,0,1,0,38.948H69.487A40.055,40.055,0,0,1,50.515,76.856,39.312,39.312,0,0,1,35.035,80ZM147.759,31.427a9.474,9.474,0,1,0,9.419,9.474A9.458,9.458,0,0,0,147.759,31.427Z",
  transform: "translate(0.904 0.23)",
  fill: "#1dbf73"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3",
  "data-name": "Rectangle",
  width: 41,
  height: 13,
  rx: 6,
  transform: "translate(84.349 33.377)",
  fill: "#1dbf73"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(18 118)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4",
  "data-name": "Rectangle",
  width: 94,
  height: 86,
  rx: 6,
  fill: "#1dbf73"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval_Copy",
  "data-name": "Oval Copy",
  cx: 2.5,
  cy: 2.567,
  rx: 2.5,
  ry: 2.567,
  transform: "translate(8 10)",
  fill: "#1dbf73"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval_Copy_22",
  "data-name": "Oval Copy 22",
  cx: 2.5,
  cy: 2.567,
  rx: 2.5,
  ry: 2.567,
  transform: "translate(15 10)",
  fill: "#33dcb2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_Copy",
  "data-name": "Rectangle Copy",
  width: 59,
  height: 5.133,
  rx: 2.567,
  transform: "translate(26 10)",
  fill: "#33dcb2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  "data-name": "Rectangle",
  width: 75,
  height: 23,
  rx: 4,
  transform: "translate(10 26)",
  fill: "#33dcb2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_Copy_2",
  "data-name": "Rectangle Copy 2",
  width: 75,
  height: 14,
  rx: 4,
  transform: "translate(10 53)",
  fill: "#33dcb2"
}));

function SvgErrorGrahpics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 376.535,
    height: 265.035,
    viewBox: "0 0 376.535 265.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorGrahpics);
export default __webpack_public_path__ + "static/media/errorGrahpics.02c29549.svg";
export { ForwardRef as ReactComponent };